// Emails autorizados a criar, editar e excluir banners. Quem não estiver na
// lista vê os botões de ação desabilitados.
export const BANNER_ADMIN_EMAILS = [
  "vmbuteri.takeat@gmail.com",
  "daniel.takeat@gmail.com",
  "danielm.takeat@gmail.com",
  "david.avanci@gmail.com",
  "gabrielafabian.takeat@gmail.com",
  "joaoclasen.takeat@gmail.com",
  "joaolucas.takeat@gmail.com",
  "jonas.takeat@gmail.com",
  "julianenascimento.takeat@gmail.com",
  "maria.takeat@gmail.com",
  "mlenke.takeat@gmail.com",
  "nicolastapias.takeat@gmail.com",
  "talles.takeat@gmail.com",
  "thomas.takeat@gmail.com",
  "adriancoradini.takeat@gmail.com",
  "alan@takeat.app",
  "guilhermeendlich.takeat@gmail.com",
  "leonardo.takeat@gmail.com",
  "mateusmascarelo.takeat@gmail.com",
  "pedro.faro@takeat.app",
];

// Retorna true se o email do usuário logado pode gerenciar banners.
export function canManageBanners(email) {
  if (!email) return false;
  return BANNER_ADMIN_EMAILS.includes(email.trim().toLowerCase());
}

// Sistemas onde um banner pode aparecer. A cor é usada só no PREVIEW do dashboard
// (cada front aplica a cor do seu próprio theme em runtime). Extensível.
export const SYSTEMS = [
  { key: "manager-area", label: "Área do Gestor", color: "#FF2C3A" },
  {
    key: "garcom-restaurant-dashboard",
    label: "Dashboard Restaurante",
    color: "#C8131B",
  },
];

export const SYSTEM_COLORS = SYSTEMS.reduce((acc, s) => {
  acc[s.key] = s.color;
  return acc;
}, {});

export const ACTION_TYPES = [
  { value: "link", label: "Abrir link" },
  { value: "whatsapp", label: "Abrir WhatsApp" },
  { value: "close", label: "Fechar modal (não mostra mais)" },
];

export const STATUS_OPTIONS = [
  { value: "draft", label: "Rascunho" },
  { value: "active", label: "Ativo" },
  { value: "archived", label: "Arquivado" },
];

export const emptyAction = () => ({
  type: "link",
  url: "",
  phone: "",
  message: "",
});

// Limpa a ação pro formato que o backend espera (só os campos do tipo).
export function cleanAction(action) {
  if (!action || !action.type) return null;
  if (action.type === "close") return { type: "close" };
  if (action.type === "link") return { type: "link", url: action.url || "" };
  if (action.type === "whatsapp") {
    const out = {
      type: "whatsapp",
      phone: (action.phone || "").replace(/\D/g, ""),
    };
    if (action.message) out.message = action.message;
    return out;
  }
  return null;
}

// Monta a URL do WhatsApp (preview).
export function buildWhatsappUrl(phone, message) {
  const digits = (phone || "").replace(/\D/g, "");
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
}
